export default __webpack_public_path__ + "static/2-c7098f620232d2c5f18cfbd1722654ba.mp4";